module.exports = __webpack_public_path__ + "83106dc1a344ae383714391aa392e1e7.svg";